export var ProjectModels;
(function (ProjectModels) {
    class ProjectReportModel {
        constructor(id, name) {
            this.id = id;
            this.name = name;
        }
    }
    ProjectModels.ProjectReportModel = ProjectReportModel;
    class ProjectValidationIssueModel {
        constructor(issue_type, item, language, issues) {
            this.issue_type = issue_type;
            this.item = item;
            this.language = language;
            this.issues = issues;
        }
    }
    ProjectModels.ProjectValidationIssueModel = ProjectValidationIssueModel;
    class ProjectInformationModel {
        constructor(id, name, environment) {
            this.id = id;
            this.name = name;
            this.environment = environment;
        }
    }
    ProjectModels.ProjectInformationModel = ProjectInformationModel;
    class ProjectVariantContentItemModel {
        constructor(id, name, codename) {
            this.id = id;
            this.name = name;
            this.codename = codename;
        }
    }
    ProjectModels.ProjectVariantContentItemModel = ProjectVariantContentItemModel;
    class ProjectVariantLanguageModel {
        constructor(id, name, codename) {
            this.id = id;
            this.name = name;
            this.codename = codename;
        }
    }
    ProjectModels.ProjectVariantLanguageModel = ProjectVariantLanguageModel;
    class ProjectVariantElementModel {
        constructor(id, name, codename) {
            this.id = id;
            this.name = name;
            this.codename = codename;
        }
    }
    ProjectModels.ProjectVariantElementModel = ProjectVariantElementModel;
    class ProjectTypeIssueModel {
        constructor(type, issues) {
            this.type = type;
            this.issues = issues;
        }
    }
    ProjectModels.ProjectTypeIssueModel = ProjectTypeIssueModel;
    class ProjectTypeModel {
        constructor(id, name, codename) {
            this.id = id;
            this.name = name;
            this.codename = codename;
        }
    }
    ProjectModels.ProjectTypeModel = ProjectTypeModel;
    class ProjectIssueModel {
        constructor(element, messages) {
            this.element = element;
            this.messages = messages;
        }
    }
    ProjectModels.ProjectIssueModel = ProjectIssueModel;
    class ProjectVariantIssueModel {
        constructor(item, language, issues) {
            this.item = item;
            this.language = language;
            this.issues = issues;
        }
    }
    ProjectModels.ProjectVariantIssueModel = ProjectVariantIssueModel;
})(ProjectModels || (ProjectModels = {}));
//# sourceMappingURL=project.models.js.map